import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import SectionHeading from "../components/SectionHeading";

function AboutContainer() {
  const { t } = useTranslation();
  const { ref, visible } = useScrollAnimation();

  return (
    <Box
      id="about"
      ref={ref}
      sx={{
        py: { xs: 4, md: 8 },
        px: 2,
        scrollMarginTop: { xs: "56px", md: "64px" },
        opacity: visible ? 1 : 0,
        transform: visible ? "none" : "translateY(40px)",
        transition: "opacity 0.7s ease, transform 0.7s ease",
      }}
    >
      <Container maxWidth="md">
        <SectionHeading tag="about" title={t("about.title")} number={1} mb={{ xs: 3, md: 4 }} />
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "0.95rem", sm: "1rem", md: "1.05rem" },
            lineHeight: 1.9,
            textAlign: "center",
            color: "text.secondary",
            mb: 2,
          }}
        >
          {t("about.bio")}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "0.95rem", sm: "1rem", md: "1.05rem" },
            lineHeight: 1.9,
            textAlign: "center",
            color: "text.secondary",
          }}
        >
          {t("about.description")}
        </Typography>
      </Container>
    </Box>
  );
}

export default AboutContainer;
